module.exports = __webpack_public_path__ + "images/feature/move-1-90f8f11466e8b108111c53ac2582a1d8.jpg";